var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "37.353px",
    height: "37.383px",
    viewBox: "13.509 5.789 37.353 37.383",
    enableBackground: "new 13.509 5.789 37.353 37.383",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M32.204,5.789c10.379,0.025,18.688,8.393,18.657,18.789c-0.03,10.283-8.438,18.622-18.75,18.594 c-10.28-0.029-18.62-8.432-18.603-18.745C13.528,14.119,21.909,5.763,32.204,5.789 M32.177,35.578c2.365,0,4.729,0.014,7.095-0.004 c2.562-0.018,4.047-1.482,4.055-4.027c0.02-4.729,0.021-9.46,0.002-14.19c-0.01-2.467-1.521-3.983-3.975-3.992 c-4.77-0.017-9.54-0.015-14.31,0.001c-2.461,0.008-3.985,1.505-3.998,3.971c-0.026,4.77-0.028,9.54,0.001,14.31 c0.016,2.412,1.52,3.896,3.914,3.924C27.366,35.596,29.771,35.575,32.177,35.578"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M32.132,34.355c-2.324,0-4.648,0.009-6.972-0.004c-1.891-0.01-2.875-0.91-2.887-2.756 c-0.028-4.768-0.03-9.536,0.001-14.304c0.012-1.764,1.025-2.705,2.816-2.71c4.728-0.013,9.456-0.012,14.184,0.001 c1.846,0.005,2.819,0.967,2.828,2.821c0.02,4.688,0.018,9.375,0,14.063c-0.007,1.949-0.946,2.874-2.879,2.885 C36.859,34.364,34.496,34.355,32.132,34.355 M37.879,24.484c0.01-3.174-2.553-5.747-5.71-5.733 c-3.115,0.013-5.648,2.536-5.674,5.651c-0.026,3.188,2.489,5.766,5.649,5.79C35.305,30.218,37.868,27.664,37.879,24.484  M39.258,14.919c-0.499,0.691-1.085,1.161-1.013,1.487c0.093,0.426,0.707,0.737,1.097,1.098c0.334-0.37,0.91-0.727,0.934-1.114 C40.296,16.009,39.755,15.595,39.258,14.919"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1664A5",
    d: "M36.662,24.477c-0.001,2.478-2.053,4.521-4.508,4.494c-2.475-0.027-4.472-2.076-4.443-4.561 c0.026-2.426,2.023-4.412,4.449-4.43C34.634,19.963,36.663,21.991,36.662,24.477"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.8a28bb0d267e51c4b951852249943073.svg";
export { ForwardRef as ReactComponent };